<script setup>
import { computed } from 'vue'

const props = defineProps({
  color: {
    type: String,
    default: "success",
  },
  size: {
    type: String,
    default: "md",
  },
})

const classes = computed(() => {
  const colorClass = props.color ? `pagination-${props.color}` : ''
  const sizeClass = props.size ? `pagination-${props.size}` : ''
  return `${colorClass} ${sizeClass}`
})


</script>

<template>
  <ul class="pagination" :class="classes">
    <slot />
  </ul>
</template>
